import React, { useState } from 'react';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Select from '../ui/Select';
import TextArea from '../ui/TextArea';
import { UnitData } from '../../data/UnitData'
import { updateItem, updateItemQuantity } from '../../services/api';
import { toast } from 'react-toastify';
import axios from 'axios';

function EditItemModal({ item, onClose, onSave, itemGroups }) {
    const [editedItem, setEditedItem] = useState(item);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [quantity, setQuantity] = useState(item.quantity);
    const [loading, setLoading] = useState(false);

    const handleUpdateQuantity = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // const response = await axios.put(`http://localhost:5000/api/items/quantity/${item._id}`, {
            // const response = await axios.put(`https://erp-server-3qrl.onrender.com/api/items/quantity/${item._id}`, {
            //     quantity: quantity.toString(), // Ensure quantity is sent as a string
            // });
            const response = await updateItemQuantity(item._id, {
                quantity: quantity.toString(), // Ensure quantity is sent as a string
            });
            setSuccess('Issue updated successfully!');
            toast.success('Item updated successfully!');
            onClose();
            onSave({
            ...editedItem
            });
            // console.log('Quantity updated:', response.data);
        } catch (err) {
            // console.error('Error updating quantity:', err);
            toast.error(err.message || 'Failed to update Item');
        } finally {
            setLoading(false);
        }
    };


    // const handleSubmit = (e) => {
    //   e.preventDefault();
    //   onSave({
    //     ...editedItem,
    //     quantity: editedItem.quantity,
    //     price: editedItem.price,
    //     costPrice: editedItem.costPrice,
    //     lowStockThreshold: editedItem.lowStockThreshold,
    //     updatedAt: new Date().toISOString()
    //   });
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const response = await updateItem(item._id, editedItem);
            setSuccess('Issue updated successfully!');
            toast.success('Item updated successfully!');
            onClose();
            onSave({
            ...editedItem
            });
            // console.log('Issue updated:', response);
            // navigate('/issues'); // Redirect to the issues list page
        } catch (err) {
            setError(err.message || 'Failed to update issue');
            toast.error(err.message || 'Failed to update Item');
        }
    };

    const userRole = localStorage.getItem('userRole');

    return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-auto z-[9999]">
        <div className="bg-white dark:bg-gray-900 p-6 rounded-lg max-w-2xl w-full max-h-screen overflow-auto">
            <h2 className="text-xl font-bold mb-4">Edit Item</h2>
            {/* {userRole === 'item_user' ? (
            <>
            <input
                type="text" // Use type="text" for string input
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="p-2 border rounded-lg w-full max-w-md"
            />
            <button
                onClick={handleUpdateQuantity}
                disabled={loading}
                className="ml-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
                {loading ? 'Updating...' : 'Update Quantity'}
            </button>
            <div className="flex justify-end space-x-2 mt-4">
                <Button type="button" onClick={onClose} variant="outline">Cancel</Button>
            </div>
            </>
            ) : ( */}
            <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
                <div>
                <label htmlFor="editName" className="block text-sm font-medium text-gray-700">Name <span className='text-red-500'>*</span></label>
                <Input
                    id="editName"
                    value={editedItem.name}
                    onChange={(e) => setEditedItem({ ...editedItem, name: e.target.value.toLowerCase() })}
                    // required
                />
                </div>
                <div>
                <label htmlFor="editAltName" className="block text-sm font-medium text-gray-700">Alternate Name</label>
                <Input
                    id="editAltName"
                    value={editedItem.altname}
                    onChange={(e) => setEditedItem({ ...editedItem, altname: e.target.value })}
                    // required
                />
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div>
                <label htmlFor="editQuantity" className="block text-sm font-medium text-gray-700">Quantity <span className='text-red-500'>*</span></label>
                <Input
                    id="editQuantity"
                    type="number"
                    value={editedItem.quantity}
                    onChange={(e) => setEditedItem({ ...editedItem, quantity: e.target.value })}
                    required
                />
                </div>
                <div>
                <label htmlFor="editUnitType" className="block text-sm font-medium text-gray-700">Unit Type</label>
                {/* <Input
                    id="editUnitType"
                    value={editedItem.unitType}
                    onChange={(e) => setEditedItem({ ...editedItem, unitType: e.target.value })}
                    placeholder="e.g., pcs, kg, liters"
                    required
                /> */}
                <Select
                    id="editUnitType"
                    value={editedItem.unitType}
                    onChange={(e) => setEditedItem({ ...editedItem, unitType: e.target.value })}
                    // required
                >
                    <option value="">Select unit</option>
                    {UnitData.map((unit) => (
                    <option key={unit.id} value={unit.name}>
                        {unit.name}
                    </option>
                    ))}
                </Select>

                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                <label htmlFor="editLowStockThreshold" className="block text-sm font-medium text-gray-700">Low Stock Threshold <span className='text-red-500'>*</span></label>
                <Input
                    id="editLowStockThreshold"
                    type="number"
                    value={editedItem.lowStockThreshold}
                    onChange={(e) => setEditedItem({ ...editedItem, lowStockThreshold: e.target.value })}
                    required
                />
                </div>
                <div>
                <label htmlFor="editGroup" className="block text-sm font-medium text-gray-700">Group <span className='text-red-500'>*</span></label>
                <Select
                    id="editGroup"
                    value={editedItem.group}
                    onChange={(e) => setEditedItem({ ...editedItem, group: e.target.value })}
                    required
                >
                    {itemGroups.map((group) => (
                    <option key={group.id} value={group.name}>
                        {group.name}
                    </option>
                    ))}
                </Select>
                </div>
            </div>
            {/* <div className="grid grid-cols-2 gap-4">
                <div>
                <label htmlFor="editPrice" className="block text-sm font-medium text-gray-700">Selling Price</label>
                <Input
                    id="editPrice"
                    type="number"
                    step="0.01"
                    value={editedItem.price}
                    onChange={(e) => setEditedItem({ ...editedItem, price: e.target.value })}
                    // required
                />
                </div>
                <div>
                <label htmlFor="editCostPrice" className="block text-sm font-medium text-gray-700">Cost Price</label>
                <Input
                    id="editCostPrice"
                    type="number"
                    step="0.01"
                    value={editedItem.costPrice}
                    onChange={(e) => setEditedItem({ ...editedItem, costPrice: e.target.value })}
                    // required
                />
                </div>
            </div> */}

            <div>
                <label htmlFor="editDescription" className="block text-sm font-medium text-gray-700">Description</label>
                <TextArea
                id="editDescription"
                value={editedItem.description}
                onChange={(e) => setEditedItem({ ...editedItem, description: e.target.value })}
                rows={3}
                />
            </div>
            {/* <div>
                <label htmlFor="editImage" className="block text-sm font-medium text-gray-700">Image URL</label>
                <Input
                id="editImage"
                type="url"
                value={editedItem.image}
                onChange={(e) => setEditedItem({ ...editedItem, image: e.target.value })}
                placeholder="https://example.com/image.jpg"
                />
            </div> */}
            <div className="flex justify-end space-x-2">
                <Button type="button" onClick={onClose} variant="outline">Cancel</Button>
                <Button type="submit">Save Changes</Button>
            </div>
            </form>
            {/* )} */}
            
        </div>
    </div>
  );
}

export default EditItemModal;